import { Box, Button, CircularProgress } from '@mui/material'
import { useGoogleLogin } from '@react-oauth/google'
import { useSetAtom } from 'jotai'
import * as React from 'react'
import { FcGoogle as GoogleIcon } from 'react-icons/fc'
import { useNavigate } from 'react-router'

import useBar from './Bar'
import { authGoogleCommandAtom } from '../../domains/auth/AuthCommand'
import { isWeChatBrowser } from '../../utils/utility'

/**
 * 社交登录按钮组件
 * @param {Object} props
 * @param {function} props.onGoogleClick - Google 登录处理函数
 * @param {function} props.onFacebookClick - Facebook 登录处理函数
 * @param {boolean} props.isSubmitting - 是否正在提交
 * @param {string} props.mode - 模式：'login' 或 'signup'
 * @param {function} props.onSetError - 设置错误信息的处理函数
 */
export default function SocialLoginButtons({ mode = 'login', onSetError = () => {} }) {
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const navigate = useNavigate()

  const authGoogleCommand = useSetAtom(authGoogleCommandAtom)
  const bar = useBar()

  const isLogin = mode === 'login'

  const handleGoogleSuccess = async (token) => {
    try {
      setIsSubmitting(true)
      await authGoogleCommand({ tokenResponse: token })
      navigate('/')
    } catch (error) {
      // Handle Google login error
      onSetError('Failed to sign in with Google. Please try again')
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: handleGoogleSuccess,
    onError: () => {
      onSetError('Failed to sign in with Google. Please try again.')
    },
    flow: 'implicit',
  })

  const googleLoginWraper = () => {
    if (isWeChatBrowser()) {
      bar.error('Google login is not available in WeChat. Please open this app in your default browser (Safari/Chrome) to continue.')
      return
    }
    handleGoogleLogin()
  }

  const handleFacebookLogin = async () => {
    navigate('/wip')
  }

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Button
          fullWidth
          variant="outlined"
          onClick={googleLoginWraper}
          disabled={isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : <GoogleIcon />}
          sx={{
            borderColor: 'grey.300',
            color: 'text.primary',
            '&:hover': {
              borderColor: 'grey.400',
              // bgcolor: 'grey.50',
            },
          }}
        >
          {isSubmitting ? (isLogin ? 'Signing in...' : 'Signing up...') : isLogin ? 'Sign in with Google' : 'Sign up with Google'}
        </Button>
        {/* <Button
          fullWidth
          variant="outlined"
          onClick={handleFacebookLogin}
          startIcon={<FacebookIcon />}
          disabled={isSubmitting}
          sx={{
            borderColor: '#1877F2',
            color: '#1877F2',
            '&:hover': {
              borderColor: '#1877F2',
              bgcolor: '#1877F21a',
            },
          }}
        >
          {isLogin ? 'Sign in with Facebook' : 'Sign up with Facebook'}
        </Button> */}
      </Box>
    </>
  )
}
